class StoreSelectButton extends HTMLElement {
  constructor() {
    super();
    this.initContent();
     window.addEventListener("storeSelected", (e) => {
        this.initContent();
    });
  }

  initContent(){
    
    const storeName = STORES_DATA.store_data.find(
      (store) => Number(store.id) === Number(localStorage.getItem("selectedStore"))
    )?.store_name;
    if (!storeName) {
      return
    }
    this.querySelector(".ssb__store-name").textContent = storeName
    
    
  }
}

customElements.define("store-select-button", StoreSelectButton);

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.locationId = localStorage.getItem("selectedStore");
    this.productId = this.dataset.productId;
    console.log("ProductCard constructor", this.locationId, this.productId);

    if (this.locationId && this.productId) {
      this._sendRequest();
    }

    if (!this.locationId) {
      window.addEventListener("storeSelected", (e) => {
        this.locationId = e.detail.storeId;
        this._sendRequest();
      });
    }
  }

  async _sendRequest() {
    try {
      const formData = new FormData();
      formData.append("locationId", this.locationId);
      formData.append("productId", this.productId);
      const config = {
        method: "POST",
        body: formData,
      };
      const response = await fetch(
        `https://organica-apps-c23e09019143f9e3995d.o2.myshopify.dev/stores`,
        config
      );
      const data = await response.json();
      if (data.ok) {
        if (!data.hasProductInLocation) {
          if (this.closest(".grid__item")) {
            this.closest(".grid__item").remove();
          } else {
            this.parentElement.remove();
          }
        }
      }
    } catch (error) {
      console.error(error);
      console.error("Something went wrong, plase reload");
    }
  }
}
customElements.define("product-card", ProductCard);

const itemRemoveLogic = async (itemsArr, oldStoreId) => {
  console.log("oldStoreId", oldStoreId);
  //first check if user agrees to remove items
  const popup = document.querySelector("clear-cart-popup");
  popup?.close();
  setTimeout(() => {
    popup?.open(itemsArr, oldStoreId);
  }, 50);
};

const checkIfItemsInCartAreAvailable = async (oldStoreId) => {
  if (!oldStoreId) return;
  try {
    const newStoreId = localStorage.getItem("selectedStore");
    const response = await fetch(window.Shopify.routes.root + "cart.js");
    const cartContents = await response.json();
    const cartItems = cartContents.items;
    if (cartContents.item_count === 0) return;
    const itemsToRemove = [];
    for (const item of cartItems) {
      console.log("item", item);
      const locationVariants = LOCATION_PRODUCT.variants.map(variant => Number(variant.id))
      if (locationVariants.includes(Number(item.id))){
        continue;
      }
      const formData = new FormData();
      formData.append("locationId", newStoreId);
      formData.append("variantId", item.id);
      const config = {
        method: "POST",
        body: formData,
      };
      const response = await fetch(
        `https://organica-apps-c23e09019143f9e3995d.o2.myshopify.dev/variant-in-cart-check`,
        config
      );
      const data = await response.json();
      console.log(data.variantInLocation)
      if (!data.variantInLocation || data.variantInLocation?.node?.quantities[0]?.quantity < item.quantity) {
        itemsToRemove.push({item, qty: data.variantInLocation?.node?.quantities[0]?.quantity || 0});
      }
    }
    const popup = document.querySelector("clear-cart-popup");
    popup?.close();
    if (itemsToRemove.length > 0) {
      await itemRemoveLogic(itemsToRemove, oldStoreId);
      return;
    }
  } catch (error) {
    console.error("Failed to fetch cart contents:", error);
  }
};

window.addEventListener("storeSelected", (e) => {
  checkIfItemsInCartAreAvailable(e.detail.oldStoreId);
});

document.addEventListener("DOMContentLoaded", () => {
  const storeSelectBtn = document.querySelector(
    ".metastock-selected-location-link"
  );

  // Función para habilitar el botón en el primer `li` con el ID predeterminado
  function enableDefaultButton() {
    const STORE_KEY = "selectedStore";
    const defaultStoreId = "69058166826";
    const popupContainer = document.getElementById("metastock-popup-container");
    const firstButton = document.querySelector(
      "#js-metastock-location-list li .metastock-store-select-button-disabled"
    );

    if (firstButton) {
      // Remover atributos de deshabilitado
      firstButton.classList.remove(
        "metastock-store-select-button-disabled",
        "button--disabled"
      );

      // Agregar clases necesarias para que se vea igual a los otros botones
      firstButton.classList.add(
        "button",
        "button--primary",
        "button--select",
        "metastock-store-select-button"
      ); // Agregar las clases necesarias

      firstButton.removeAttribute("disabled");

      // Agregar el `storeId` predeterminado
      firstButton.setAttribute(
        "onclick",
        `MetastockFlyout.selectLocation(${defaultStoreId})`
      );
      firstButton.textContent = "Shop this store"; // Actualizar el texto si es necesario

      // También cerramos el popup si el usuario hace clic en este botón
      firstButton.addEventListener("click", function () {
        localStorage.setItem(STORE_KEY, defaultStoreId);
        popupContainer.style.display = "none";
        document.body.classList.remove("noScroll");
      });
    }
  }

  if (storeSelectBtn) {
    storeSelectBtn.addEventListener("click", () => {
      const popupContainer = document.getElementById(
        "metastock-popup-container"
      );
      const popupOverlay = popupContainer.querySelector(
        "#metastock-popup-overlay"
      );

      popupContainer.style.display = "block";
      enableDefaultButton();

      popupOverlay.addEventListener("click", () => {
        if (localStorage.getItem("selectedStore")) {
          popupContainer.style.display = "none";
        }
      });
    });
  }
});

class ClearCartPopup extends HTMLElement {
  constructor() {
    super();
    this._init();

    this.ccpCount = this.querySelector(".ccp__count");
    this.templateItem = this.querySelector("#ccp-template-item");
    this.ccpItems = this.querySelector(".ccp__items");
  }

  _init() {
    this.querySelector(".ccp__header").innerHTML = this.querySelector(
      ".ccp__header"
    ).innerHTML.replace("ccp__count", `<span class="ccp__count">0</span>`);
  }

  _closePopup() {
    this.style.display = "none";

  }
  close() {
    this._closePopup();
  }

  async _removeItems(itemsArr) {
    //if user agrees, remove items
    const updates = {};
    itemsArr.forEach((itemObj) => {
      updates[itemObj.item.key] = itemObj.qty || 0;
    });
    try {
      const response = await fetch(
        window.Shopify.routes.root + "cart/update.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates }),
        }
      );
      const result = await response.json();
      if (result.status === 422) {
        console.error("Error:", result);
      }
      window.location.reload();
    } catch (error) {
      console.error("Error:", error);
    }
  }

  _renderItems(itemsArr) {
    if ("content" in document.createElement("template")) {
      this.ccpCount.innerHTML = itemsArr.length;
      this.ccpItems.innerHTML = "";
      itemsArr.forEach((itemObj) => {
        const item = itemObj.item;
        const clone = this.templateItem.content.cloneNode(true);
        const img = clone.querySelector(".ccp__item-image");
        img.src = item.featured_image.url;
        img.height = item.featured_image.height;
        img.width = item.featured_image.width;
        img.alt = item.featured_image.alt;
        const title = clone.querySelector(".ccp__item-title");
        title.textContent = item.title;
        const qunaity = clone.querySelector(".ccp__item-quantity--old");
        const quantityNew = clone.querySelector(".ccp__item-quantity--new");
        qunaity.textContent = "QTY: " + item.quantity;
        quantityNew.textContent = "QTY: " + itemObj.qty;
        this.ccpItems.appendChild(clone);
      });
    }
  }

  open(itemsArr, oldStoreId) {
    const items = itemsArr.map(item => item.item)
    this.cartItems = items;

    this.style.display = "flex";
    this._renderItems(itemsArr);
    this.querySelector(".ccp__button--confirm").addEventListener(
      "click",
      () => {
        this._removeItems(itemsArr);

        this._closePopup();
      }
    );
    this.querySelectorAll(".cp__overlay, .ccp__button--cancel").forEach(
      (el) => {
        el.addEventListener("click", () => {
          localStorage.setItem("selectedStore", oldStoreId);
          this._closePopup();
        });
      }
    );
  }
}
customElements.define("clear-cart-popup", ClearCartPopup);


const setUrlsForLocations = () => {
  const storeName = STORES_DATA.store_data.find(storeData => storeData.id == Number(localStorage.getItem("selectedStore"))
      ).store_name
  if (TEMPLATE_NAME == 'collection' || TEMPLATE_NAME == 'search'){
    const url = new URL(window.location.href);
    // const searchParams = new URLSearchParams(paramsString);
    if(!url.searchParams.get("filter.p.m.custom.available_locations")){
      url.searchParams.append("filter.p.m.custom.available_locations", storeName)
      url.searchParams.sort();
      console.log(url.toString())
      window.location.href = url.toString();
    } 
  } else {
    document.querySelectorAll('a[href*="/collections/"]').forEach(anchor => {
        const url = new URL(anchor.href, window.location.origin);
        url.searchParams.set("filter.p.m.custom.available_locations", storeName);
        anchor.href = url.toString();
    });
  }
}

async function addCorrectLocationVariant(){
  try {
    // Fetch current cart information
    const cartResponse = await fetch('/cart.js');
    if (!cartResponse.ok) {
      throw new Error('Failed to fetch cart data');
    }
    const cartData = await cartResponse.json();

    // Remove any items with product_id equal to LOCATION_PRODUCT.id
    for (const item of cartData.items) {
      if (item.product_id === LOCATION_PRODUCT.id) {
        const removeResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: item.key,
            quantity: 0
          })
        });
        if (!removeResponse.ok) {
          throw new Error(`Failed to remove product with id ${item.product_id}`);
        }
        // Optionally, you can log or process the response after removal
        const removedItem = await removeResponse.json();
        console.log('Removed item:', removedItem);
      }
    }

    // Get store name from localStorage via STORES_DATA
    const selectedStore = localStorage.getItem("selectedStore");
    const storeName = STORES_DATA.store_data.find(
      (store) => Number(store.id) === Number(selectedStore)
    )?.store_name;
    
    if (!storeName) {
      throw new Error("Store name not found in STORES_DATA");
    }
    const storeNameLower = storeName.toLowerCase();

    // Find the variant whose title matches the store name (case-insensitive)
    const matchingVariant = LOCATION_PRODUCT.variants.find(variant => {
      // Assumes variant.title is the property that holds the variant name.
      return variant.title.toLowerCase() === storeNameLower;
    });

    if (!matchingVariant) {
      throw new Error("No matching variant found for the store");
    }

    // Add the matched variant to the cart
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        quantity: 1,
        id: matchingVariant.id,
        properties: {
          nota: "Este producto se utilizará únicamente para guardar la ubicación seleccionada"
        }
      })
    });

    if (!addResponse.ok) {
      throw new Error("Failed to add the matching variant to the cart");
    }
    const addedItem = await addResponse.json();
    console.log("Product added successfully:", addedItem);
    
  } catch (error) {
    console.error("Error updating cart:", error);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  console.log("here!");
  setUrlsForLocations();
})


window.addEventListener("storeSelected", (e) => {
  console.log("here as well!");
  setUrlsForLocations();
  addCorrectLocationVariant();
});




